module.exports = __webpack_public_path__ + "static/media/apartment3.6fbd60a8.jpg";